import { Component, Input, Output } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { FormType, NGX_SUB_FORM_HANDLE_VALUE_CHANGES_RATE_STRATEGIES, createForm } from "ngx-sub-form";
import { Subject } from "rxjs";
import { EditUserPermissions, UserRoles } from "./user-model";

@Component({
  selector: 'app-edit-permissions-form',
  template: `
      <form [formGroup]="form.formGroup">
        <div class="flex flex-col space-y-4">
          @if (isScimUser) {
            <div
              class="p-3 bg-yellow-900/30 border-l-4 border-yellow-400 rounded text-yellow-200 text-sm">
              <i class="pi pi-exclamation-triangle mr-2"></i>
              This user's roles are managed by IT via Active Directory groups. Changes here will not take effect.
            </div>
          }
          <app-user-permissions-form 
            [formControlName]="form.formControlNames.roles"
            [disabled]="isScimUser">
          </app-user-permissions-form>
          <p-button (onClick)="save()" label="Save" [disabled]="isScimUser"/>
        </div>
      </form>
    `,
  standalone: false
})
export class EditPermissionsFormComponent {

  public isScimUser = false;
  private input$ = new Subject<EditUserPermissions | undefined>();

  @Input() set userPermissions(userPermissions: EditUserPermissions | undefined) {
    this.input$.next(userPermissions);
    // Check if this is a SCIM user by examining the authId
    if (userPermissions) {
      const user = userPermissions as any;
      this.isScimUser = user.authId?.startsWith('waad|') ?? false;
    }
  }

  private disabled$ = new Subject<boolean>();
  @Input() set disabled(value: boolean | undefined) {
    this.disabled$.next(!!value);
  }

  @Output() permissionsUpdated = new Subject<EditUserPermissions>();

  manualSave$ = new Subject<void>();

  public form = createForm<EditUserPermissions, EditUserPermissions>(this, {
    formType: FormType.ROOT,
    disabled$: this.disabled$,
    input$: this.input$,
    output$: this.permissionsUpdated,
    manualSave$: this.manualSave$,
    formControls: {
      id: new UntypedFormControl(),
      authId: new UntypedFormControl(),
      roles: new UntypedFormControl(new UserRoles())
    },
    handleEmissionRate: NGX_SUB_FORM_HANDLE_VALUE_CHANGES_RATE_STRATEGIES.debounce(1000)
  });

  save() {
    this.manualSave$.next();
  }

}